import { render, staticRenderFns } from "./AddShelterFee.vue?vue&type=template&id=3c3866a6&scoped=true"
import script from "./AddShelterFee.vue?vue&type=script&setup=true&lang=js"
export * from "./AddShelterFee.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddShelterFee.vue?vue&type=style&index=0&id=3c3866a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3866a6",
  null
  
)

export default component.exports